// extracted by mini-css-extract-plugin
export default {"nav":"Header_nav__IIF23","headerContent":"Header_headerContent__prDjQ"};